export default "__VITE_ASSET__DDslng8q__"